/* PavCon, LLC Proprietary.All rights reserved 2022 */

import { IState, initStores } from './shared/store/root.store';
import { NavigationEnd, Router } from '@angular/router';

import { Actions } from '@ngrx/effects';
import { BnNgIdleService } from 'bn-ng-idle';
import CognitoService from '../app/shared/services/cognito';
import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserPageActions } from './shared/store/actions/userActions';
import { AppSnackbarService } from './shared/services/app-snackbar.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocalStorageService } from './shared/services/local-storage.service';
import { AppUserActions } from './shared/store/app-user.reducer';
import { AppParamsActions } from './shared/store/app-params.reducer';
import { AppActions } from './shared/store/app.reducer';
import { RulesEngineActions } from './shared/store/rules-engine.reducer';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'CRISTL-FE';
  signOutTime = 900; // In seconds default 900
  isStoreInitialized = false;
  private destroy$ = new Subject<void>();

  constructor(
    private bnIdle: BnNgIdleService,
    private router: Router,
    private localCognitoService: CognitoService,
    private store: Store<IState>,
    private modalService: NgbModal,
    private snackBar: AppSnackbarService,
    private dialogRef: MatDialog,
    private localStorage: LocalStorageService,
    private $localActions: Actions<UserPageActions.Actions>
  ) {
    // Store initialization is now handled by APP_INITIALIZER
    // This ensures initialization happens BEFORE any guards or components
    this.isStoreInitialized = true;
  }

  ngOnInit(): void {

    this.$localActions.pipe(
      takeUntil(this.destroy$)
    ).subscribe((event) => {
      if (event.type === UserPageActions.SEND_GLOBAL_MESSAGE) {
        this.snackBar.open('Alert', event.payload.message, 4000);
      }
    });

    this.bnIdle.startWatching(this.signOutTime).pipe(
      takeUntil(this.destroy$)
    ).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        try {
          // close any opened modals
          this.modalService.dismissAll(); // ngbModal modals
          this.dialogRef.closeAll(); // matDialog modals
          // sign out user
          this.localCognitoService
            .globalSignOut()
            .then(() => {
              // Clear all localStorage
              this.localStorage.clearAll();

              // Reset all stores
              this.store.dispatch({ type: RulesEngineActions.CLEAR_LAST_STATE });
              this.store.dispatch({ type: AppUserActions.INIT });
              this.store.dispatch({ type: AppParamsActions.INIT });
              this.store.dispatch({ type: AppActions.INIT });

              this.redirectToLogin();
            })
            .catch(() => {
              this.onFailure();
            });
        } catch {
          //  console.log("already logged out")
        }
      }
    });

    this.router.events.pipe(
      takeUntil(this.destroy$)
    ).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Store is already initialized in constructor, no need to do it again
        // This was causing race conditions with NgRx Effects
      }
    });
  }

  onFailure = () => {
    //  console.log("caught the fail")
  }

  redirectToLogin = () => {
    this.router.navigate(['/auth/login']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
/* PavCon, LLC Proprietary.All rights reserved 2022 */
